import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'
import lookups from '@/assets/json/clientLookups.json'

const getAdressesBookPreferencesSettings = async () => {
  const formStore = useFormStore()

  const result = await apiHelperService.get(
    `/api/addressesBook/management/getAdressesBookPreferencesSettings`
  )
  formStore.extraMap.addressesBookPreferences = result
}
const prepareUserAddresses = async () => {
  const formStore = useFormStore()
}

const searchPassports = async () => {
  const formStore = useFormStore()

  let { identityNumber, unifiedNumber, guardianFamilyCityAndSequence } =
    router.currentRoute.value.query

  const guardianShipFamilyCityCode = guardianFamilyCityAndSequence?.split('-')?.[0]
  const guardianShipFamilySequence = guardianFamilyCityAndSequence?.split('-')?.[1]

  const searchOptions = {
    IdentityNumber: identityNumber,
    UnifiedNumber: unifiedNumber,
    familyCityCode: guardianShipFamilyCityCode,
    familySequence: guardianShipFamilySequence
  }
  const res = await apiHelperService.post('/api/individual/passportInfo', searchOptions)
  if (res && res.numberOfRecords > 0) {
    const findItem = res.collection.find(
      (passportItem) => passportItem.identityNumber.trim() == identityNumber.trim()
    )
    if (findItem) {
      formStore.form.setFieldValue('passportNumber', findItem.passportNumber)
    } else {
      formStore.extraMap.hasActivePassport = false
    }
  }
}

export default async function () {
  const formStore = useFormStore()

  try {
    formStore.extraMap = {
      hasActivePassport: false,
      addressesBookPreferences: []
    }

    await prepareUserAddresses()
    await searchPassports()
    await getAdressesBookPreferencesSettings()
  } catch (error) {
    console.error('use693Preload', error)
  }
}
